// material
import React, { useState, useContext, useEffect } from 'react';
import { Container } from '@mui/material';
// components
import Page from '../../components/Page';
import MesaList from '../../sections/products/MesasList';
import {totalVendasMesa, consMesa} from '../../services/api';
import { AuthContext } from '../../contexts/auth';  

import Mesa from '../../images/mesa.png'

// ----------------------------------------------------------------------

export default function VendaPorMesa() {
  const { logout } = useContext(AuthContext);

  const [dados, setDados] = useState([]);

  const getVendas = async () => {
    
    const responsePrincipal = await consMesa();
    
    if(responsePrincipal.erro === true) {
      if (responsePrincipal.mensagem === 'O Token é inválido!' || responsePrincipal.mensagem === 'Acesso negado!'){
        logout();
      }
    }else {
      responsePrincipal.data.forEach(async (valores) => {
        
        const response = await totalVendasMesa(valores.id_mesa);
        
        if(response.erro === true) {
          if (response.mensagem === 'O Token é inválido!' || response.mensagem === 'Acesso negado!'){
            logout();
          }
        }else {
           const json = {id: valores.id_mesa, 
                         cover: Mesa,
                         name: `MESA - ${valores.codigo_mesa}`,
                         price: response.data[0].total_venda,
                         };

           setDados(dados => [...dados, json]); 
        };                    
      });
    }; 
  };

  useEffect(() => {
    setDados([]);
    getVendas();
  },[])

  return (
    <Page title="Mesas">
      <Container>
        <MesaList products={dados} />
      </Container>
    </Page>
  );
}
